function UploadProgressIndicator({ uploadCount }) {
  if (uploadCount <= 0) return null;

  return (
    <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg flex items-center gap-3">
      <div className="flex-shrink-0">
        <svg className="animate-spin h-5 w-5 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </div>
      <div className="flex-1">
        <span className="text-sm font-medium text-blue-800">
          Upload en cours de {uploadCount} fichier{uploadCount > 1 ? 's' : ''}...
        </span>
        <p className="text-xs text-blue-700 mt-1">
          Merci de patienter pendant la compression et l'upload de vos fichiers
        </p>
      </div>
    </div>
  );
}

export default UploadProgressIndicator;
